import { DisplayPageType } from "@faire/web-api/indigofair/data/DisplayPageType";
import { IBannerComponent } from "@faire/web-api/indigofair/data/IBannerComponent";
import { IImage } from "@faire/web-api/indigofair/data/IImage";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import classNames from "classnames";
import React from "react";

import {
  objectFitCoverImageStyles,
  SDUIImage,
} from "@faire/retailer/components/SDUI/__internal__/Image/SDUIImage";
import { getCssAlignmentValue } from "@faire/retailer/components/SDUI/__internal__/Styling/getCssAlignmentValue";
import {
  convertServerResponsivePropertyToClientResponsiveProperty,
  getResponsiveValueAtIndex,
} from "@faire/retailer/components/SDUI/__internal__/Styling/responsiveValues";
import {
  ComponentLoggingEventParams,
  SDUIComponentRenderBehaviour,
} from "@faire/retailer/components/SDUI/__internal__/types";
import { SDUIBannerTextContent } from "@faire/retailer/components/SDUI/ComponentRenderers/Banner/__internal__/BannerTextContent/SDUIBannerTextContent";
import * as styles from "@faire/retailer/components/SDUI/ComponentRenderers/Banner/__internal__/ImageBannerV2/styles/SDUIImageBannerV2Renderer.css";
import { IMAGE_BANNER_HEIGHTS } from "@faire/retailer/components/SDUI/ComponentRenderers/Banner/__internal__/ImageBannerV2/styles/SDUIImageBannerV2Renderer.css";

type SDUIImageBannerV2Props = {
  bannerComponent: IBannerComponent;
  loggingData: ComponentLoggingEventParams;
  renderBehaviour?: SDUIComponentRenderBehaviour;
};

export const SDUIImageBannerV2Renderer = ({
  bannerComponent,
  loggingData,
  renderBehaviour,
}: SDUIImageBannerV2Props) => {
  const { images, responsive_images, vertical_content_alignment } =
    bannerComponent;

  const responsiveImages =
    convertServerResponsivePropertyToClientResponsiveProperty(
      images,
      (img) => img,
      responsive_images
    );

  return (
    <div
      className={classNames(
        styles.imageBannerV2Wrapper,
        // TODO - padding should be defined in the component width instead of applying
        // view-specific styling. Need to revisit component width definitions.
        loggingData.view_display_page === DisplayPageType.HOMEPAGE
          ? styles.desktopHomepagePaddingWrapper
          : undefined
      )}
    >
      <SDUIImage
        responsiveImage={getResponsiveValueAtIndex(
          responsiveImages,
          0,
          IImage.build()
        )}
        optimizeImageOptions={{
          mobileAndAbove: { height: IMAGE_BANNER_HEIGHTS.mobileAndAbove },
          tabletAndAbove: { height: IMAGE_BANNER_HEIGHTS.tabletAndAbove },
          desktopAndAbove: { height: IMAGE_BANNER_HEIGHTS.desktopAndAbove },
        }}
        className={styles.backgroundImageWrapper}
        imageStyles={objectFitCoverImageStyles}
        renderBehaviour={renderBehaviour}
      />
      <div
        className={styles.imageBannerV2ContentWrappper}
        style={assignInlineVars({
          [styles.verticalContentAlignment]: `${getCssAlignmentValue(
            vertical_content_alignment,
            "center"
          )}`,
        })}
      >
        <SDUIBannerTextContent
          className={styles.imageBannerV2Content}
          data-test-id="image-banner-v2-content"
          bannerComponent={bannerComponent}
          loggingData={loggingData}
        />
      </div>
    </div>
  );
};
